import React, { useEffect, useMemo, useRef, useState } from "react";
import styled from "styled-components";
import { getEventInfo } from "utils/event";
import { getNumber } from "utils/format";

export const RollingPicker = (props) => {
  const self = useRef();
  const [value, setValue] = useState(props.value || "");
  const [eventInfo] = useState({
    y: 0,
    id: 0,
    positionY: 0,
    maxPositionY: 0,
    min: 0,
    max: 0,
    timestamp: 0,
  });

  useEffect(() => {
    if (eventInfo.node) {
      const length = optionList.length - 1;
      eventInfo.max = length;
      eventInfo.maxPositionY = eventInfo.nodeHeight * length * -1;
      eventInfo.nodeList = eventInfo.node.querySelectorAll("li");
      if (eventInfo.maxPositionY > eventInfo.positionY)
        eventHandler.setFocusByValue(props.value);
    }
  }, [props.options]);

  useEffect(() => {
    const container = self.current;
    if (!container) return;

    const length = optionList.length - 1;
    eventInfo.node = container.querySelector("ul");
    eventInfo.nodeList = container.querySelectorAll("li");
    const height = (eventInfo.nodeHeight =
      eventInfo?.nodeList?.[0]?.offsetHeight);
    if (height) {
      eventInfo.max = length;
      eventInfo.maxPositionY = height * length * -1;

      container.style.height = height * 5 + "px";
      eventInfo.node.style.top = height * 2 + "px";
      document.onmousemove = document.onmouseup = null;

      eventHandler.setFocusByValue(value, false);
    }
  }, []);

  useEffect(() => {
    if (props.onChange) props.onChange(value);
  }, [value]);

  const eventHandler = {
    touchDown: (event) => {
      eventInfo.node.classList.add("focus");
      event = getEventInfo(event);
      if (!event) return;
      eventInfo.y = event.y;
      eventInfo.id = event.id;
      eventInfo.timestamp = Date.now();
      if (event.type == "mousedown") {
        document.onmousemove = eventHandler.touchMove;
        document.onmouseup = eventHandler.touchUp;
      }
    },
    touchMove: (event) => {
      event = getEventInfo(event, eventInfo.id);
      const positionY = eventInfo.positionY + (event.y - eventInfo.y);
      eventHandler.setFocusByPosition(positionY);
    },
    touchUp: (event) => {
      if (event.type == "mouseup")
        document.onmousemove = document.onmouseup = null;
      eventInfo.node.classList.remove("focus");
      event = getEventInfo(event, eventInfo.id);

      let positionY = event.y - eventInfo.y + eventInfo.positionY;
      positionY =
        Math.round(positionY / eventInfo.nodeHeight) * eventInfo.nodeHeight;

      const max = eventInfo.max * eventInfo.nodeHeight * -1;
      if (positionY < max) positionY = max;
      if (positionY > 0) positionY = 0;
      eventInfo.positionY = positionY;

      eventInfo.isClick =
        eventInfo.timestamp + 300 > Date.now() &&
        Math.abs(eventInfo.y - event.y) < 5;
      eventHandler.setFocusByPosition(positionY);

      setValue(optionList[eventInfo.index].value);

      if (props.isRepeat) {
        const node = eventInfo.nodeList[eventInfo.index];
        const value = node.getAttribute("data-value");
        if (value.indexOf("clone") > -1) {
          setTimeout(() => {
            const reValue = value.split("-")[1];
            eventHandler.setFocusByValue(reValue, false);
          }, 400);
        }
      }
    },
    setFocusByIndex: (index) => {
      if (!eventInfo.isClick) return;
      const positionY = index * eventInfo.nodeHeight * -1;
      eventInfo.positionY = positionY;
      eventHandler.setFocusByPosition(positionY);
      setValue(optionList[eventInfo.index].value);
    },
    setFocusByValue: (value, isAnimation) => {
      eventInfo.node.classList.add("none");

      eventHandler.setFocusByPosition(0);
      eventInfo.positionY = 0;
      eventInfo.nodeList.forEach((item, index) => {
        if (item.getAttribute("data-value") == value) {
          const positionY = index * eventInfo.nodeHeight * -1;
          eventHandler.setFocusByPosition(positionY);
          eventInfo.positionY = positionY;
        }
      });
      setTimeout(() => {
        eventInfo.node.classList.remove("none");
      }, 100);
    },
    setFocusByPosition: (positionY) => {
      let focusIndex = Math.round(positionY / eventInfo.nodeHeight) * -1;
      if (focusIndex < 0) focusIndex = 0;
      if (focusIndex > eventInfo.max) focusIndex = eventInfo.max;

      if (positionY > 0) positionY = positionY * 0.25;
      else if (positionY < eventInfo.maxPositionY)
        positionY =
          eventInfo.maxPositionY - (eventInfo.maxPositionY - positionY) * 0.25;
      eventInfo.node.style.transform = `translateY(${positionY}px)`;

      eventInfo.nodeList.forEach((item, index) => {
        item.classList.remove("focus");
        if (index == focusIndex) {
          item.classList.add("focus");
          eventInfo.index = index;
        }
      });
    },
  };

  let optionList = props.options || [];
  if (props.isRepeat) {
    const getOptionList = (start, end) => {
      return JSON.parse(JSON.stringify(optionList))
        .slice(start, end)
        .map((item) => {
          item.isClone = true;
          return item;
        });
    };
    optionList = [].concat(
      getOptionList(-10),
      optionList,
      getOptionList(0, 10)
    );
  }

  const li = optionList.map((item, index) => {
    return (
      <li
        key={index}
        data-value={(item.isClone ? "clone-" : "") + item.value}
        onClick={() => {
          eventHandler.setFocusByIndex(index);
        }}
      >
        <span dangerouslySetInnerHTML={{ __html: item.label }} />
      </li>
    );
  });

  return (
    <Wrapper
      ref={self}
      onMouseDown={eventHandler.touchDown}
      onTouchStart={eventHandler.touchDown}
      onTouchMove={eventHandler.touchMove}
      onTouchEnd={eventHandler.touchUp}
    >
      <ul>{li}</ul>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  & {
    position: relative;
    user-select: none;
    overflow: hidden;
    cursor: grab;
  }
  ul {
    position: absolute;
    left: 0;
    width: 100%;
    transition: transform 0.4s;
  }
  ul.focus {
    transition: transform 0.1s;
  }
  ul li {
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0.33;
    transition: opacity 0.25s;
  }
  ul li.focus {
    opacity: 1;
  }
  ul.none,
  ul.none li {
    transition: none;
  }
`;

export default RollingPicker;
